import * as React from "react";
import { connect } from "react-redux";

import Header from "./header";
import Footer from "./footer";
import MenuAndContact from "./menuAndContact";
import SitecontactDetails from "./sitecontactDetails";
import CONFIG from "./config";

class Layout extends React.Component {
  render() {
    let title = this.props.title || "";
    if (!title) {
      title = CONFIG.SHOP_NAME +
        (this.props.configStorage.isAnkaufShop()
          ? "-Ankauf"
          : "-Bestellung"
        );
    }

    return (<div className="par parsys full-screen" role="main" aria-label={title}>
      <Header />
      <div className="par parsys">
        <section className="if6_outer section if6_section full-height">
          <div className="if6_inner full-height">
            {this.props.children}
            {this.props.configStorage.isKundenShop()
              ? <SitecontactDetails />
              : null
            }
            {!this.props.configStorage.isKundenShop() && this.props.configStorage.hasMenu()
              ? <MenuAndContact />
              : null
            }
          </div>
        </section>
      </div>
      <Footer />
    </div>
    );
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage
  };
})(Layout);
